// extracted by mini-css-extract-plugin
module.exports = {"list":"list--2wbr2","item":"item--3FTWu","selected":"selected--qE5Wn","block":"block--8wq2d","relationbtn":"relationbtn--1w1OU","header":"header--1wd7P","section":"section--i0mAU","section__blocks":"section__blocks--gGygY","uihidden":"uihidden--5e397","uivisible":"uivisible--3ndzq"};
    if(module.hot) {
      // 1732531518681
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  